import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import apiRequest from '../../../../helpers/apiRequest';
import * as endpoints from '../../../../helpers/endpoints';
import Modal from '../../../ui/modal';
import Textfield from '../../../ui/text-field';
import { last, sortBy } from 'lodash';

import _ from 'lodash';

import Autosuggest from '../../../ui/auto-suggest';
import validObj from '../../../../helpers/validateObj';
import aaSave from '../../../../helpers/afterActionSave';
import aaValidation from '../../../../helpers/afterActionValidation';

class PromoItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAction: null,
            lineItems: [],
            selectedLineItem: {}
        };
    }
    handleSubmit = e => {
        const formObj = validObj(e);
        formObj.id = formObj.reportId;
        switch (this.state.userAction) {
            case 'add':
                this.addPromoItem();
                break;
            case 'save':
                formObj.deliverable = formObj.aadeliverable;
                formObj.recommend = formObj.aaRecommend;
                formObj.approverId = formObj.aaApproverId;
                this.props.updateAfterAction(formObj);
                break;
            case 'submit':
                const notValid = aaValidation(e);
                if (!notValid) {
                    formObj.recommend = formObj.aaRecommend;
                    formObj.deliverable = formObj.aadeliverable;
                    this.props.submitAfterAction(formObj);
                } else {
                    this.props.setEventErrorMessage(notValid);
                    if (e.aaawareness !== true && e.aabehavior !== true) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            false
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            false
                        );
                    } else if (
                        e.aaawareness === true ||
                        e.aabehavior === true
                    ) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            true
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            true
                        );
                    }
                }
                break;
            case 'approve':
                this.props.approveAfterAction(formObj);
                break;
            case 'request':
                this.props.requestInfoAfterAction(formObj);
                break;
            default:
                console.log(this.state.userAction);
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }
        if (this.state.userAction === 'add') {
            this.addPromoItem();
        } else if (this.state.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
    };

    getItems = e => {
        if (e.target.value.length > 1) {
            apiRequest(
                `${endpoints.PROMO_ITEMS}/search?name=${e.target.value}`,
                this.props.jwtToken
            ).then(results => {
                let lineItems = results.data;
                this.setState({ lineItems });
            });
            this.setState({ showAutoSuggest: true });
        } else if (e.target.value.length < 1) {
            this.setState({ lineItems: [] });
            this.setState({ showAutoSuggest: false });
        }
    };

    setItem = e => {
        const target = e.target;
        const index = target.getAttribute('data-index');
        const lineObject = this.state.lineItems[index];
        this.setState({ selectedLineItem: lineObject });
        this.props.loadPromoItem(lineObject);
        this.setState({ showAutoSuggest: false });
    };

    addPromoItem() {
        let object = this.props.eventForm.newPromoLineItem;
        if (object !== undefined && object.name && object.quantity) {
            this.props.addPromoLineItem(object);
            this.props.clearPromoLineItem({});
        } else {
            alert('Please fill out the form before you can add a promo item.');
        }
    }

    removePromoItem = e => {
        this.setState({ userAction: 'remove' });
        const target = e.target;
        const id = target.getAttribute('data-index');
        const promoItemId = this.props.eventForm.PromotionalItem[id];
        this.props.deletePromoItemThunk(id, promoItemId);
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.eventForm !== this.props.eventForm) {
            let promoItems = nextProps.eventForm.PromotionalItem;
            let valueArray = [];

            for (let i = 0; i < promoItems.length; i++) {
                let item = promoItems[i];
                let qty = item.quantity;
                let value = +qty;
                valueArray.push(value);
            }

            let updatedValue = _.sum(valueArray);

            this.props.updatePromoItemsTotal(updatedValue);
        }
    }

    componentDidMount() {
        let promoItems = this.props.eventForm.PromotionalItem;
        let valueArray = [];

        for (let i = 0; i < promoItems.length; i++) {
            let item = promoItems[i];
            let qty = item.quantity;
            let value = +qty;
            valueArray.push(value);
        }

        let updatedValue = _.sum(valueArray);

        this.props.updatePromoItemsTotal(updatedValue);
    }

    render() {
        const showDropdown = this.state.showAutoSuggest;
        let dropdown = null;
        if (showDropdown) {
            dropdown = (
                <div className="promo-items__entry">
                    <Autosuggest
                        onClick={this.setItem}
                        listValues={this.state.lineItems}
                    />
                </div>
            );
        }

        let saveSubmit = false;
        let approveReject = false;

        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;

        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                } else {
                    approveReject = true;
                }
            }
        }

        let promoLineItem = this.props.eventForm.PromotionalItem.map(
            (item, index) => {
                return (
                    <div className="promo-item" key={index}>
                        <Textfield
                            model={`event.PromotionalItem[${index}].quantity`}
                            title={
                                this.props.eventForm.PromotionalItem[index].name
                            }
                            type="number"
                            disabled={!saveSubmit}
                        />
                        {saveSubmit && (
                            <button
                                onClick={this.removePromoItem}
                                data-index={index}
                                className="promo-items__btn"
                            >
                                <svg className="icon icon-minus">
                                    <use
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        xlinkHref="#icon-minus"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                );
            }
        );

        return (
            <Form
                className="form"
                model="event"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Promo Items</div>
                <p>
                    Please list all promotional items and quantities distributed
                    at the event.
                </p>
                <div className="form__row">
                    <div className="form__section-title">
                        Add Promotional Items
                    </div>
                    <div className="promo-items">
                        <div className="promo-items__entry">
                            <Textfield
                                model="event.newPromoLineItem.name"
                                title="New Promo Item"
                                disabled={!saveSubmit}
                                onChange={this.getItems}
                            />
                            <Textfield
                                model="event.newPromoLineItem.quantity"
                                title="Quantity"
                                type="number"
                                disabled={!saveSubmit}
                                onKeyPress
                                min="0"
                            />
                            <div className="promo-items__actions">
                                {saveSubmit ? (
                                    <button
                                        onClick={() => {
                                            this.setState({
                                                userAction: 'add'
                                            });
                                        }}
                                        className="promo-items__btn"
                                    >
                                        <svg className="icon icon-plus">
                                            <use
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                xlinkHref="#icon-plus"
                                            />
                                        </svg>
                                    </button>
                                ) : null}
                            </div>
                        </div>
                        {dropdown}
                    </div>
                </div>

                {promoLineItem}

                <Textfield
                    model="event.promoTotal"
                    title="Total"
                    type="number"
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.setState({ userAction: 'save' });
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.setState({ userAction: 'submit' });
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.setState({ userAction: 'approve' });
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Request Information"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Request Information
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Request Information Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default PromoItems;



// WEBPACK FOOTER //
// ./src/components/event/after-action/promo-items/index.js